import { Component, Input } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div>
  <se-po-registration-list [personaId]="personaId">
  </se-po-registration-list>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class RegistrationListExampleComponent {

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-registration-list-example',
  template,
  styleUrls: ['./registration-list-docs.component.scss'],
  standalone: false,
})
export class RegistrationListExampleComponent extends SeFeDocsExampleComponent {
  @Input() public personaId: string | number
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  constructor() {
    super()
  }
}
